import { Alert, AlertDescription } from '@/components/ui/alert';
import { Lock } from 'lucide-react';

export const ReadOnlyBanner = () => {
  return (
    <Alert className="rounded-none border-x-0 border-t-0 bg-yellow-50 dark:bg-yellow-950/20 border-yellow-200 dark:border-yellow-800">
      <Lock className="h-4 w-4 text-yellow-600 dark:text-yellow-500" />
      <AlertDescription className="text-yellow-800 dark:text-yellow-200 font-medium">
        Platform is temporarily in read-only mode. You can view data but cannot make changes at this time.
      </AlertDescription>
    </Alert>
  );
};
